import peopleImg from "../../images/people.png";
import papa from "../../images/papa.png";

const Header = () => {
  return (
    <header id="homeHeader">
      <div className="container">
        <div className="content">
          <h1>
            Find Your Fit.
            <br />
            Shape Your Future.
          </h1>
          <p className="lgText">
            Great Appers uses AI to uncover your unique strengths and guide you
            toward the right career, college, or study abroad opportunity
            <br />— so every application you make is a confident step forward.
          </p>
          <div className="actions flex align-center gap-25">
            <a href="/contact" className="button white-button">
              Start Skill Assessment
            </a>
            <a href="/contact" className="button yellow-button">
              Get Career Guidance
            </a>
          </div>
          <div className="people flex align-center gap-8">
            <img src={peopleImg} alt="People" />
            <span>1500+ Students & Professionals</span>
          </div>
        </div>
        <img src={papa} alt="gr8-appers-header-image" className="papa-img" />
      </div>
    </header>
  );
};

export default Header;
